import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Avatar } from "@domestika-dev/prudencio/dist/atoms/Avatar";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Portlet } from "@domestika-dev/prudencio/dist/atoms/Portlet";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { FormattedMessage } from "react-intl";
import { LiveSessionContext } from "../../../context/LiveSessionContext";
import * as LiveSessionStates from "../../../constants/liveSessionStates";
import { PlayerGoLiveButton } from "./PlayerGoLiveButton";
import { PlayerFinishLiveButton } from "./PlayerFinishLiveButton";
import { getAssetPath } from "../../../utils/assetsUtils";

export const PlayerFooter = ({ footerRef, goLiveButtonDisabled }) => {
  const { course, liveSession, isTeacher } = useContext(LiveSessionContext);

  return (
    <div ref={footerRef}>
      <Portlet paddingX={5} paddingY={5}>
        <Grid gridColumnGap={[4, 4, 4]} gridTemplateColumns="48px 1fr">
          <GridItem gridColumn="1" gridRow="1">
            <Avatar src={getAssetPath(course?.teacher.avatar?.url)} size="small" />
          </GridItem>
          <GridItem gridColumn="2" gridRow="1">
            <Grid gridRowGap={[1, 1, 1]}>
              <GridItem gridColumn="1" gridRow="1">
                <Text size="medium" fontWeight="medium" as="h1" textAlign="left">
                  {liveSession?.title}
                </Text>
              </GridItem>
              <GridItem gridColumn="1" gridRow="2">
                <Text size="tiny" fontWeight="regular" as="h4" textAlign="left">
                  <FormattedMessage
                    id="live_sessions.video_player.footer.student.teacher_course"
                    values={{
                      teacher: <strong>{course?.teacher.name}</strong>,
                      course: course?.title,
                    }}
                  />
                </Text>
              </GridItem>
            </Grid>
          </GridItem>
          {isTeacher && (
            <GridItem gridColumn="8" gridRow="1">
              {{
                [LiveSessionStates.SCHEDULED]: () => <></>,
                [LiveSessionStates.READY]: () => (
                  <PlayerGoLiveButton disabled={goLiveButtonDisabled} />
                ),
                [LiveSessionStates.STREAMING]: () => <PlayerFinishLiveButton />,
                [LiveSessionStates.FINISHED]: () => <></>,
              }[liveSession?.aasmState]()}
            </GridItem>
          )}
        </Grid>
      </Portlet>
    </div>
  );
};

PlayerFooter.propTypes = {
  footerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.elementType }),
  ]),
  goLiveButtonDisabled: PropTypes.bool,
};

PlayerFooter.defaultProps = {
  footerRef: null,
  goLiveButtonDisabled: false,
};

export default PlayerFooter;
